// extracted by mini-css-extract-plugin
export default {"icon":"FeatureEdInfoIcon--icon--COxgC","header":"FeatureEdInfoIcon--header--xtxIw","content":"FeatureEdInfoIcon--content--lQmOl"};